var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 17L4 21L13.1721 4.12326C14.6468 1.40984 18.5095 1.3201 20.1086 3.96211L28 17Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.125C14 21.6364 15.1552 20.4297 16.5801 20.4297C18.0051 20.4297 19.1603 21.6364 19.1603 23.125C19.1603 24.6136 18.0051 25.8203 16.5801 25.8203C15.1552 25.8203 14 24.6136 14 23.125Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5466 18.7102L14.1305 10.7414C14.1095 10.3387 14.4164 10 14.8025 10H18.3577C18.7438 10 19.0508 10.3387 19.0297 10.7414L18.6137 18.7102C18.5942 19.0831 18.2991 19.375 17.9416 19.375H15.2187C14.8612 19.375 14.5661 19.0831 14.5466 18.7102Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1961 5.11079C17.9757 2.91571 14.8908 2.97443 13.7538 5.22394L3.85959 24.7996C2.75285 26.9893 4.33463 29.5 6.61076 29.5H27.3886C29.7178 29.5 31.2991 26.8796 30.0798 24.6864L19.1961 5.11079ZM11.0764 3.87067C13.296 -0.520774 19.4255 -0.6504 21.8181 3.65301L32.7018 23.2287C34.9755 27.3182 32.1228 32.5 27.3886 32.5H6.61076C1.98571 32.5 -0.881668 27.5296 1.18215 23.4463L11.0764 3.87067Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic_alert.b82e27a8d11cbb148985a1e562409267.svg";
export { ForwardRef as ReactComponent };